import { render } from "./DoctorProfile.vue?vue&type=template&id=779d7648&scoped=true"
import script from "./DoctorProfile.vue?vue&type=script&lang=js"
export * from "./DoctorProfile.vue?vue&type=script&lang=js"

import "./DoctorProfile.vue?vue&type=style&index=0&id=779d7648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779d7648"]])

export default __exports__